export default {
  getSource(cashflowData, year) {
    if (cashflowData.some(datum => datum.year === year && datum.source === 'tax_transcript')) {
      return 'tax_transcript'
    } else if (cashflowData.some(datum => datum.year === year && datum.source === 'manual_transcript')) {
      return 'manual_transcript'
    } else if (cashflowData.some(datum => datum.year === year && datum.source === 'manual_document')) {
      return 'manual_document'
    } else if (cashflowData.some(datum => datum.year === year && datum.source === 'extracted_document')) {
      return 'extracted_document'
    }
  }
}
